<template>
    <div>
        <v-row>
            <v-col cols="12" md="6">
                <div class="field_label">Nom de la campagne <span class="text-red">*</span></div>
                <v-text-field v-model="campaignStore.name" required :rules="[$formRules.required]"></v-text-field>
                <div class="field_label">A quelle liste de contacts doit être envoyée la campagne ? <span
                        class="text-red">*</span></div>
                <v-select v-model="campaignStore.id_contacts_list" :items="contactsLists" item-title="name"
                    item-value="id" required :rules="[$formRules.required]"
                    placeholder="Choisissez une liste de contacts"></v-select>
                <SportipsButton @onClick="nextStep" chevron fullWidth>Etape suivante
                </SportipsButton>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { useCampaignStore } from "@/stores/mailingSystem/campaignStore";
import { mapStores } from "pinia";
import AdminService from "@/services/admin.service";
import { useMainStore } from "@/stores/mainStore";
export default {
    computed: {
        ...mapStores(useCampaignStore),
        ...mapStores(useMainStore),
    },
    data() {
        return {
            contactsLists: []
        }
    },
    methods: {
        nextStep() {
            if (this.campaignStore.name == "" || this.campaignStore.id_contacts_list == null) {
                this.mainStore.notification.send("Veuillez remplir tous les champs", "error");
            } else {
                this.campaignStore.current_step = 2;
            }
        },
    },
    async mounted() {
        let request = await AdminService.fetchAllContactsLists(this.mainStore.module.id);
        if (request) {
            this.contactsLists = request;
        }

    }
}
</script>

<style lang="scss" scoped></style>